import React, { useState, useEffect } from 'react'
import Logo from '../../images/logo512.png'
import {Link}  from 'react-router-dom'
import HeaderTopbar from '../HeaderTopbar'
import MobileMenu from '../../components/MobileMenu'
import './style.css'

const Header = () => {
     const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            event.preventDefault();
            setDeferredPrompt(event);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the install prompt');
                } else {
                    console.log('User dismissed the install prompt');
                }
                setDeferredPrompt(null);
            });
        }
    };

    return(	
        <div className="middle-header">
            <HeaderTopbar/>
            <div className="header-style-3">
                <div className="container">
                    <div className="header-content">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                            <div className="logo">
                                <Link onClick={ClickHandler} to="/home" title=""><img src={Logo} alt=""/></Link>
                            </div>
                        </div>
                        <div className="col-lg-9 d-lg-block d-none">
                            <nav>
                                <ul>
                                    <li><Link onClick={ClickHandler} className="active" to="/home" title="">Home</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about" title="">About</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service" title="">Courses</Link>
                                        <ul>
                                            <li><Link onClick={ClickHandler} to="/basic-qaida" title="">Basic Qaida</Link></li>
                                            <li><Link onClick={ClickHandler} to="/tajweed" title="">Tajweed</Link></li>
                                            <li><Link onClick={ClickHandler} to="/tajweed-improvement" title="">Tajweed Improvement</Link></li>
                                            <li><Link onClick={ClickHandler} to="/hifz" title="">Hifz (Memorisation)</Link></li>
                                        </ul>
                                    </li>
+                                   <li><Link to="/home#reviews" title="">Reviews</Link></li>
                                    <li><Link onClick={ClickHandler} to="/blog">Blogs</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact" title="">Contact</Link></li>
                                    {deferredPrompt && (
                                        <li>
                                            <button
                                                onClick={handleInstallClick}
                                                className="theme-btn-s3"
                                                style={{
                                                    marginLeft: '10px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '8px 15px',
                                                    borderRadius: '5px',
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                Install App
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-2 col-2 d-lg-none">
                            <MobileMenu/>
                        </div>
                    </div>
                    
                        <div className="clearfix"></div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Header;